import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { UserService } from "@estatex/services";
import { RegisterRequest, ToFormGroup } from "@estatex/types";

@Component({
    selector: "lib-register",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: "./register.component.html",
    styleUrl: "./register.component.css",
})
export class RegisterComponent {
    registerForm = this.fb.group<ToFormGroup<RegisterRequest>>({
        name: this.fb.control("", [Validators.required]),
        username: this.fb.control("", [Validators.required]),
        email: this.fb.control("", [Validators.required, Validators.email]),
        password: this.fb.control("", [Validators.required]),
    });

    constructor(private fb: FormBuilder, private userService: UserService) {}

    register(): void {
        if (this.registerForm.invalid) {
            return;
        }
        this.userService.register(this.registerForm.getRawValue()).subscribe();
    }
}
